"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageCourseAdministrationApi = exports.PackageCourseAdministrationApiFactory = exports.PackageCourseAdministrationApiFp = exports.PackageCourseAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * PackageCourseAdministrationApi - axios parameter creator
 * @export
 */
const PackageCourseAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: AddSetToTraining - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremana set ekler. Dikkat: coverPhoto alanı base64 formatında gelecektir.
         * @param {AddSetToTrainingCommand} [addSetToTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSetToTraining: (addSetToTrainingCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/add_set_to_training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addSetToTrainingCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: AddTrainingToPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket derse antreman ekler. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {AddTrainingToPackageCourseCommand} [addTrainingToPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrainingToPackageCourse: (addTrainingToPackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/add_training_to_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addTrainingToPackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: CreatePackageCourse - Difficulty: 5 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket ders oluşturur. Dikkat: Gönderilen tüm imajlar base64 formatında gelecektir.
         * @param {CreatePackageCourseCommand} [createPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackageCourse: (createPackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/create_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeletePackageCourse - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin, altındaki tüm antremanların ve antremanların altında bulunan tüm setlerin silindi olarak işaretlenmesini sağlar. Dikkat: Silinme işlemi aslında sadece isDeleted kısmının true olarak güncellenmesinden ibarettir.
         * @param {DeletePackageCourseCommand} [deletePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackageCourse: (deletePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/delete_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteSetFromTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setini veritabanında IsDeleted = true olarak ayarlar.
         * @param {DeleteSetFromTrainingCommand} [deleteSetFromTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSetFromTraining: (deleteSetFromTrainingCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/delete_set_from_training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteSetFromTrainingCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: DeleteTrainingFromPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket kursun içerisinden bir antremanı, kendine bağlı bulunan antreman setleri ile birlikte IsDeleted = true durumuna geçirir.
         * @param {DeleteTrainingFromPackageCourseCommand} [deleteTrainingFromPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingFromPackageCourse: (deleteTrainingFromPackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/delete_training_from_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteTrainingFromPackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetPackageCourseDetailsForAdministration - Difficulty: 3 - Roles can execute: SuperAdmin
         * @summary Paket dersin detaylarını yönetim için getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz.
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageCourseDetailsForAdministration: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/get_package_course_details_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListPackageCoursesForAdministration - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary PackageCourse entity\'sindeki id alanına göre tersten sıralanmalıdır. Sayfa başına 50 adet kayıt dönmelidir. Paket kurslardaki CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. PromotionalVimeoUrl alanını doldurmak için VimeoService.GetVideoUrl metodunu kullanabilirsiniz. Bu metodun parametresine veritabanında bulunan vimeo_promotional_video_id alanından gelen değeri gönderiniz. Dikkat: Entity\'lerde sadece isDeleted = false olanları listeleyiniz. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageCoursesForAdministration: (page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'page' is not null or undefined
            (0, common_1.assertParamExists)('listPackageCoursesForAdministration', 'page', page);
            const localVarPath = `/api/package_course_administration/list_package_courses_for_administration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateAppleProductIdOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin apple product idsini günceller
         * @param {UpdateAppleProductIdOfThePackageCourseCommand} [updateAppleProductIdOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppleProductIdOfThePackageCourse: (updateAppleProductIdOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_apple_product_id_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateAppleProductIdOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateCoverPhotoOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin kapak fotoğrafını güncelleştirir. Dikkat: Gönderilen imaj base64 formatında olacaktır.
         * @param {UpdateCoverPhotoOfThePackageCourseCommand} [updateCoverPhotoOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfThePackageCourse: (updateCoverPhotoOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_cover_photo_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoverPhotoOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateCoverPhotoOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
         * @param {UpdateCoverPhotoOfTrainingCommand} [updateCoverPhotoOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfTraining: (updateCoverPhotoOfTrainingCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_cover_photo_of_training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoverPhotoOfTrainingCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateCoverPhotoOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
         * @param {UpdateCoverPhotoOfTrainingSetCommand} [updateCoverPhotoOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfTrainingSet: (updateCoverPhotoOfTrainingSetCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_cover_photo_of_training_set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCoverPhotoOfTrainingSetCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateDescriptionOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin açıklamasını günceller.
         * @param {UpdateDescriptionOfThePackageCourseCommand} [updateDescriptionOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfThePackageCourse: (updateDescriptionOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_description_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDescriptionOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateDescriptionOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın açıklamasını günceller.
         * @param {UpdateDescriptionOfTrainingCommand} [updateDescriptionOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfTraining: (updateDescriptionOfTrainingCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_description_of_training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDescriptionOfTrainingCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateDescriptionOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin açıklamasını günceller.
         * @param {UpdateDescriptionOfTrainingSetCommand} [updateDescriptionOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfTrainingSet: (updateDescriptionOfTrainingSetCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_description_of_training_set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDescriptionOfTrainingSetCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateIosPriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin ios fiyatını günceller.
         * @param {UpdateIosPriceOfThePackageCourseCommand} [updateIosPriceOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosPriceOfThePackageCourse: (updateIosPriceOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_ios_price_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateIosPriceOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateNameOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin ismini günceller.
         * @param {UpdateNameOfThePackageCourseCommand} [updateNameOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameOfThePackageCourse: (updateNameOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_name_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateNameOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePcOrderOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin sırasını günceller.
         * @param {UpdatePcOrderOfThePackageCourseCommand} [updatePcOrderOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePcOrderOfThePackageCourse: (updatePcOrderOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_pc_order_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePcOrderOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePersonalTrainerOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersi çeken antrenörü günceller.
         * @param {UpdatePersonalTrainerOfThePackageCourseCommand} [updatePersonalTrainerOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalTrainerOfThePackageCourse: (updatePersonalTrainerOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_personal_trainer_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePersonalTrainerOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin fiyatını günceller.
         * @param {UpdatePriceOfThePackageCourseCommand} [updatePriceOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceOfThePackageCourse: (updatePriceOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_price_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePriceOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePromotionalVimeoUrlOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin tanıtım videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {UpdatePromotionalVimeoUrlOfThePackageCourseCommand} [updatePromotionalVimeoUrlOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromotionalVimeoUrlOfThePackageCourse: (updatePromotionalVimeoUrlOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_promotional_vimeo_url_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePromotionalVimeoUrlOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdatePublishStateOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin yayın durumunu günceller
         * @param {UpdatePublishStateOfThePackageCourseCommand} [updatePublishStateOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublishStateOfThePackageCourse: (updatePublishStateOfThePackageCourseCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_publish_state_of_the_package_course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePublishStateOfThePackageCourseCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateTitleOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın başlığını günceller.
         * @param {UpdateTitleOfTrainingCommand} [updateTitleOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfTraining: (updateTitleOfTrainingCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_title_of_training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTitleOfTrainingCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateTitleOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin başlığını günceller.
         * @param {UpdateTitleOfTrainingSetCommand} [updateTitleOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfTrainingSet: (updateTitleOfTrainingSetCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_title_of_training_set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTitleOfTrainingSetCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: UpdateVimeoVideoUrlOfTheTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {UpdateVimeoVideoUrlOfTheTrainingCommand} [updateVimeoVideoUrlOfTheTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVimeoVideoUrlOfTheTraining: (updateVimeoVideoUrlOfTheTrainingCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course_administration/update_vimeo_video_url_of_the_training`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateVimeoVideoUrlOfTheTrainingCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PackageCourseAdministrationApiAxiosParamCreator = PackageCourseAdministrationApiAxiosParamCreator;
/**
 * PackageCourseAdministrationApi - functional programming interface
 * @export
 */
const PackageCourseAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PackageCourseAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: AddSetToTraining - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremana set ekler. Dikkat: coverPhoto alanı base64 formatında gelecektir.
         * @param {AddSetToTrainingCommand} [addSetToTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSetToTraining(addSetToTrainingCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addSetToTraining(addSetToTrainingCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: AddTrainingToPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket derse antreman ekler. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {AddTrainingToPackageCourseCommand} [addTrainingToPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrainingToPackageCourse(addTrainingToPackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTrainingToPackageCourse(addTrainingToPackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: CreatePackageCourse - Difficulty: 5 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket ders oluşturur. Dikkat: Gönderilen tüm imajlar base64 formatında gelecektir.
         * @param {CreatePackageCourseCommand} [createPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackageCourse(createPackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPackageCourse(createPackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeletePackageCourse - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin, altındaki tüm antremanların ve antremanların altında bulunan tüm setlerin silindi olarak işaretlenmesini sağlar. Dikkat: Silinme işlemi aslında sadece isDeleted kısmının true olarak güncellenmesinden ibarettir.
         * @param {DeletePackageCourseCommand} [deletePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackageCourse(deletePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePackageCourse(deletePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteSetFromTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setini veritabanında IsDeleted = true olarak ayarlar.
         * @param {DeleteSetFromTrainingCommand} [deleteSetFromTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSetFromTraining(deleteSetFromTrainingCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSetFromTraining(deleteSetFromTrainingCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: DeleteTrainingFromPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket kursun içerisinden bir antremanı, kendine bağlı bulunan antreman setleri ile birlikte IsDeleted = true durumuna geçirir.
         * @param {DeleteTrainingFromPackageCourseCommand} [deleteTrainingFromPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingFromPackageCourse(deleteTrainingFromPackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTrainingFromPackageCourse(deleteTrainingFromPackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetPackageCourseDetailsForAdministration - Difficulty: 3 - Roles can execute: SuperAdmin
         * @summary Paket dersin detaylarını yönetim için getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz.
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageCourseDetailsForAdministration(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPackageCourseDetailsForAdministration(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListPackageCoursesForAdministration - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary PackageCourse entity\'sindeki id alanına göre tersten sıralanmalıdır. Sayfa başına 50 adet kayıt dönmelidir. Paket kurslardaki CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. PromotionalVimeoUrl alanını doldurmak için VimeoService.GetVideoUrl metodunu kullanabilirsiniz. Bu metodun parametresine veritabanında bulunan vimeo_promotional_video_id alanından gelen değeri gönderiniz. Dikkat: Entity\'lerde sadece isDeleted = false olanları listeleyiniz. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageCoursesForAdministration(page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPackageCoursesForAdministration(page, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateAppleProductIdOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin apple product idsini günceller
         * @param {UpdateAppleProductIdOfThePackageCourseCommand} [updateAppleProductIdOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppleProductIdOfThePackageCourse(updateAppleProductIdOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAppleProductIdOfThePackageCourse(updateAppleProductIdOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateCoverPhotoOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin kapak fotoğrafını güncelleştirir. Dikkat: Gönderilen imaj base64 formatında olacaktır.
         * @param {UpdateCoverPhotoOfThePackageCourseCommand} [updateCoverPhotoOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfThePackageCourse(updateCoverPhotoOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCoverPhotoOfThePackageCourse(updateCoverPhotoOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateCoverPhotoOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
         * @param {UpdateCoverPhotoOfTrainingCommand} [updateCoverPhotoOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfTraining(updateCoverPhotoOfTrainingCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCoverPhotoOfTraining(updateCoverPhotoOfTrainingCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateCoverPhotoOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
         * @param {UpdateCoverPhotoOfTrainingSetCommand} [updateCoverPhotoOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfTrainingSet(updateCoverPhotoOfTrainingSetCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCoverPhotoOfTrainingSet(updateCoverPhotoOfTrainingSetCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateDescriptionOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin açıklamasını günceller.
         * @param {UpdateDescriptionOfThePackageCourseCommand} [updateDescriptionOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfThePackageCourse(updateDescriptionOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDescriptionOfThePackageCourse(updateDescriptionOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateDescriptionOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın açıklamasını günceller.
         * @param {UpdateDescriptionOfTrainingCommand} [updateDescriptionOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfTraining(updateDescriptionOfTrainingCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDescriptionOfTraining(updateDescriptionOfTrainingCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateDescriptionOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin açıklamasını günceller.
         * @param {UpdateDescriptionOfTrainingSetCommand} [updateDescriptionOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfTrainingSet(updateDescriptionOfTrainingSetCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDescriptionOfTrainingSet(updateDescriptionOfTrainingSetCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateIosPriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin ios fiyatını günceller.
         * @param {UpdateIosPriceOfThePackageCourseCommand} [updateIosPriceOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosPriceOfThePackageCourse(updateIosPriceOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIosPriceOfThePackageCourse(updateIosPriceOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateNameOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin ismini günceller.
         * @param {UpdateNameOfThePackageCourseCommand} [updateNameOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameOfThePackageCourse(updateNameOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateNameOfThePackageCourse(updateNameOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePcOrderOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin sırasını günceller.
         * @param {UpdatePcOrderOfThePackageCourseCommand} [updatePcOrderOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePcOrderOfThePackageCourse(updatePcOrderOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePcOrderOfThePackageCourse(updatePcOrderOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePersonalTrainerOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersi çeken antrenörü günceller.
         * @param {UpdatePersonalTrainerOfThePackageCourseCommand} [updatePersonalTrainerOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalTrainerOfThePackageCourse(updatePersonalTrainerOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePersonalTrainerOfThePackageCourse(updatePersonalTrainerOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin fiyatını günceller.
         * @param {UpdatePriceOfThePackageCourseCommand} [updatePriceOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceOfThePackageCourse(updatePriceOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePriceOfThePackageCourse(updatePriceOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePromotionalVimeoUrlOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin tanıtım videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {UpdatePromotionalVimeoUrlOfThePackageCourseCommand} [updatePromotionalVimeoUrlOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromotionalVimeoUrlOfThePackageCourse(updatePromotionalVimeoUrlOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePromotionalVimeoUrlOfThePackageCourse(updatePromotionalVimeoUrlOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdatePublishStateOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin yayın durumunu günceller
         * @param {UpdatePublishStateOfThePackageCourseCommand} [updatePublishStateOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublishStateOfThePackageCourse(updatePublishStateOfThePackageCourseCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePublishStateOfThePackageCourse(updatePublishStateOfThePackageCourseCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateTitleOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın başlığını günceller.
         * @param {UpdateTitleOfTrainingCommand} [updateTitleOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfTraining(updateTitleOfTrainingCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTitleOfTraining(updateTitleOfTrainingCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateTitleOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin başlığını günceller.
         * @param {UpdateTitleOfTrainingSetCommand} [updateTitleOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfTrainingSet(updateTitleOfTrainingSetCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTitleOfTrainingSet(updateTitleOfTrainingSetCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: UpdateVimeoVideoUrlOfTheTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {UpdateVimeoVideoUrlOfTheTrainingCommand} [updateVimeoVideoUrlOfTheTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVimeoVideoUrlOfTheTraining(updateVimeoVideoUrlOfTheTrainingCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateVimeoVideoUrlOfTheTraining(updateVimeoVideoUrlOfTheTrainingCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PackageCourseAdministrationApiFp = PackageCourseAdministrationApiFp;
/**
 * PackageCourseAdministrationApi - factory interface
 * @export
 */
const PackageCourseAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PackageCourseAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: AddSetToTraining - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremana set ekler. Dikkat: coverPhoto alanı base64 formatında gelecektir.
         * @param {AddSetToTrainingCommand} [addSetToTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSetToTraining(addSetToTrainingCommand, options) {
            return localVarFp.addSetToTraining(addSetToTrainingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: AddTrainingToPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket derse antreman ekler. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {AddTrainingToPackageCourseCommand} [addTrainingToPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrainingToPackageCourse(addTrainingToPackageCourseCommand, options) {
            return localVarFp.addTrainingToPackageCourse(addTrainingToPackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: CreatePackageCourse - Difficulty: 5 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket ders oluşturur. Dikkat: Gönderilen tüm imajlar base64 formatında gelecektir.
         * @param {CreatePackageCourseCommand} [createPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPackageCourse(createPackageCourseCommand, options) {
            return localVarFp.createPackageCourse(createPackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeletePackageCourse - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin, altındaki tüm antremanların ve antremanların altında bulunan tüm setlerin silindi olarak işaretlenmesini sağlar. Dikkat: Silinme işlemi aslında sadece isDeleted kısmının true olarak güncellenmesinden ibarettir.
         * @param {DeletePackageCourseCommand} [deletePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePackageCourse(deletePackageCourseCommand, options) {
            return localVarFp.deletePackageCourse(deletePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteSetFromTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setini veritabanında IsDeleted = true olarak ayarlar.
         * @param {DeleteSetFromTrainingCommand} [deleteSetFromTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSetFromTraining(deleteSetFromTrainingCommand, options) {
            return localVarFp.deleteSetFromTraining(deleteSetFromTrainingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: DeleteTrainingFromPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket kursun içerisinden bir antremanı, kendine bağlı bulunan antreman setleri ile birlikte IsDeleted = true durumuna geçirir.
         * @param {DeleteTrainingFromPackageCourseCommand} [deleteTrainingFromPackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingFromPackageCourse(deleteTrainingFromPackageCourseCommand, options) {
            return localVarFp.deleteTrainingFromPackageCourse(deleteTrainingFromPackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetPackageCourseDetailsForAdministration - Difficulty: 3 - Roles can execute: SuperAdmin
         * @summary Paket dersin detaylarını yönetim için getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz.
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageCourseDetailsForAdministration(id, options) {
            return localVarFp.getPackageCourseDetailsForAdministration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListPackageCoursesForAdministration - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary PackageCourse entity\'sindeki id alanına göre tersten sıralanmalıdır. Sayfa başına 50 adet kayıt dönmelidir. Paket kurslardaki CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. PromotionalVimeoUrl alanını doldurmak için VimeoService.GetVideoUrl metodunu kullanabilirsiniz. Bu metodun parametresine veritabanında bulunan vimeo_promotional_video_id alanından gelen değeri gönderiniz. Dikkat: Entity\'lerde sadece isDeleted = false olanları listeleyiniz. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {number} page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageCoursesForAdministration(page, options) {
            return localVarFp.listPackageCoursesForAdministration(page, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateAppleProductIdOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin apple product idsini günceller
         * @param {UpdateAppleProductIdOfThePackageCourseCommand} [updateAppleProductIdOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppleProductIdOfThePackageCourse(updateAppleProductIdOfThePackageCourseCommand, options) {
            return localVarFp.updateAppleProductIdOfThePackageCourse(updateAppleProductIdOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateCoverPhotoOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin kapak fotoğrafını güncelleştirir. Dikkat: Gönderilen imaj base64 formatında olacaktır.
         * @param {UpdateCoverPhotoOfThePackageCourseCommand} [updateCoverPhotoOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfThePackageCourse(updateCoverPhotoOfThePackageCourseCommand, options) {
            return localVarFp.updateCoverPhotoOfThePackageCourse(updateCoverPhotoOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateCoverPhotoOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
         * @param {UpdateCoverPhotoOfTrainingCommand} [updateCoverPhotoOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfTraining(updateCoverPhotoOfTrainingCommand, options) {
            return localVarFp.updateCoverPhotoOfTraining(updateCoverPhotoOfTrainingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateCoverPhotoOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
         * @param {UpdateCoverPhotoOfTrainingSetCommand} [updateCoverPhotoOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoverPhotoOfTrainingSet(updateCoverPhotoOfTrainingSetCommand, options) {
            return localVarFp.updateCoverPhotoOfTrainingSet(updateCoverPhotoOfTrainingSetCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateDescriptionOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin açıklamasını günceller.
         * @param {UpdateDescriptionOfThePackageCourseCommand} [updateDescriptionOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfThePackageCourse(updateDescriptionOfThePackageCourseCommand, options) {
            return localVarFp.updateDescriptionOfThePackageCourse(updateDescriptionOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateDescriptionOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın açıklamasını günceller.
         * @param {UpdateDescriptionOfTrainingCommand} [updateDescriptionOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfTraining(updateDescriptionOfTrainingCommand, options) {
            return localVarFp.updateDescriptionOfTraining(updateDescriptionOfTrainingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateDescriptionOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin açıklamasını günceller.
         * @param {UpdateDescriptionOfTrainingSetCommand} [updateDescriptionOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDescriptionOfTrainingSet(updateDescriptionOfTrainingSetCommand, options) {
            return localVarFp.updateDescriptionOfTrainingSet(updateDescriptionOfTrainingSetCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateIosPriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin ios fiyatını günceller.
         * @param {UpdateIosPriceOfThePackageCourseCommand} [updateIosPriceOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIosPriceOfThePackageCourse(updateIosPriceOfThePackageCourseCommand, options) {
            return localVarFp.updateIosPriceOfThePackageCourse(updateIosPriceOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateNameOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin ismini günceller.
         * @param {UpdateNameOfThePackageCourseCommand} [updateNameOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameOfThePackageCourse(updateNameOfThePackageCourseCommand, options) {
            return localVarFp.updateNameOfThePackageCourse(updateNameOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePcOrderOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin sırasını günceller.
         * @param {UpdatePcOrderOfThePackageCourseCommand} [updatePcOrderOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePcOrderOfThePackageCourse(updatePcOrderOfThePackageCourseCommand, options) {
            return localVarFp.updatePcOrderOfThePackageCourse(updatePcOrderOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePersonalTrainerOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersi çeken antrenörü günceller.
         * @param {UpdatePersonalTrainerOfThePackageCourseCommand} [updatePersonalTrainerOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalTrainerOfThePackageCourse(updatePersonalTrainerOfThePackageCourseCommand, options) {
            return localVarFp.updatePersonalTrainerOfThePackageCourse(updatePersonalTrainerOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin fiyatını günceller.
         * @param {UpdatePriceOfThePackageCourseCommand} [updatePriceOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriceOfThePackageCourse(updatePriceOfThePackageCourseCommand, options) {
            return localVarFp.updatePriceOfThePackageCourse(updatePriceOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePromotionalVimeoUrlOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir paket dersin tanıtım videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {UpdatePromotionalVimeoUrlOfThePackageCourseCommand} [updatePromotionalVimeoUrlOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromotionalVimeoUrlOfThePackageCourse(updatePromotionalVimeoUrlOfThePackageCourseCommand, options) {
            return localVarFp.updatePromotionalVimeoUrlOfThePackageCourse(updatePromotionalVimeoUrlOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdatePublishStateOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Paket dersin yayın durumunu günceller
         * @param {UpdatePublishStateOfThePackageCourseCommand} [updatePublishStateOfThePackageCourseCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublishStateOfThePackageCourse(updatePublishStateOfThePackageCourseCommand, options) {
            return localVarFp.updatePublishStateOfThePackageCourse(updatePublishStateOfThePackageCourseCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateTitleOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın başlığını günceller.
         * @param {UpdateTitleOfTrainingCommand} [updateTitleOfTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfTraining(updateTitleOfTrainingCommand, options) {
            return localVarFp.updateTitleOfTraining(updateTitleOfTrainingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateTitleOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antreman setinin başlığını günceller.
         * @param {UpdateTitleOfTrainingSetCommand} [updateTitleOfTrainingSetCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTitleOfTrainingSet(updateTitleOfTrainingSetCommand, options) {
            return localVarFp.updateTitleOfTrainingSet(updateTitleOfTrainingSetCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: UpdateVimeoVideoUrlOfTheTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
         * @summary Bir antremanın videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
         * @param {UpdateVimeoVideoUrlOfTheTrainingCommand} [updateVimeoVideoUrlOfTheTrainingCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVimeoVideoUrlOfTheTraining(updateVimeoVideoUrlOfTheTrainingCommand, options) {
            return localVarFp.updateVimeoVideoUrlOfTheTraining(updateVimeoVideoUrlOfTheTrainingCommand, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PackageCourseAdministrationApiFactory = PackageCourseAdministrationApiFactory;
/**
 * PackageCourseAdministrationApi - object-oriented interface
 * @export
 * @class PackageCourseAdministrationApi
 * @extends {BaseAPI}
 */
class PackageCourseAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: AddSetToTraining - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antremana set ekler. Dikkat: coverPhoto alanı base64 formatında gelecektir.
     * @param {AddSetToTrainingCommand} [addSetToTrainingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    addSetToTraining(addSetToTrainingCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).addSetToTraining(addSetToTrainingCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: AddTrainingToPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket derse antreman ekler. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
     * @param {AddTrainingToPackageCourseCommand} [addTrainingToPackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    addTrainingToPackageCourse(addTrainingToPackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).addTrainingToPackageCourse(addTrainingToPackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: CreatePackageCourse - Difficulty: 5 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Paket ders oluşturur. Dikkat: Gönderilen tüm imajlar base64 formatında gelecektir.
     * @param {CreatePackageCourseCommand} [createPackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    createPackageCourse(createPackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).createPackageCourse(createPackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeletePackageCourse - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin, altındaki tüm antremanların ve antremanların altında bulunan tüm setlerin silindi olarak işaretlenmesini sağlar. Dikkat: Silinme işlemi aslında sadece isDeleted kısmının true olarak güncellenmesinden ibarettir.
     * @param {DeletePackageCourseCommand} [deletePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    deletePackageCourse(deletePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).deletePackageCourse(deletePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteSetFromTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antreman setini veritabanında IsDeleted = true olarak ayarlar.
     * @param {DeleteSetFromTrainingCommand} [deleteSetFromTrainingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    deleteSetFromTraining(deleteSetFromTrainingCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).deleteSetFromTraining(deleteSetFromTrainingCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: DeleteTrainingFromPackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Paket kursun içerisinden bir antremanı, kendine bağlı bulunan antreman setleri ile birlikte IsDeleted = true durumuna geçirir.
     * @param {DeleteTrainingFromPackageCourseCommand} [deleteTrainingFromPackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    deleteTrainingFromPackageCourse(deleteTrainingFromPackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).deleteTrainingFromPackageCourse(deleteTrainingFromPackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetPackageCourseDetailsForAdministration - Difficulty: 3 - Roles can execute: SuperAdmin
     * @summary Paket dersin detaylarını yönetim için getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz.
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    getPackageCourseDetailsForAdministration(id, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).getPackageCourseDetailsForAdministration(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListPackageCoursesForAdministration - Difficulty: 4 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary PackageCourse entity\'sindeki id alanına göre tersten sıralanmalıdır. Sayfa başına 50 adet kayıt dönmelidir. Paket kurslardaki CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. PromotionalVimeoUrl alanını doldurmak için VimeoService.GetVideoUrl metodunu kullanabilirsiniz. Bu metodun parametresine veritabanında bulunan vimeo_promotional_video_id alanından gelen değeri gönderiniz. Dikkat: Entity\'lerde sadece isDeleted = false olanları listeleyiniz. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    listPackageCoursesForAdministration(page, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).listPackageCoursesForAdministration(page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateAppleProductIdOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Paket dersin apple product idsini günceller
     * @param {UpdateAppleProductIdOfThePackageCourseCommand} [updateAppleProductIdOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateAppleProductIdOfThePackageCourse(updateAppleProductIdOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateAppleProductIdOfThePackageCourse(updateAppleProductIdOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateCoverPhotoOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Paket dersin kapak fotoğrafını güncelleştirir. Dikkat: Gönderilen imaj base64 formatında olacaktır.
     * @param {UpdateCoverPhotoOfThePackageCourseCommand} [updateCoverPhotoOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateCoverPhotoOfThePackageCourse(updateCoverPhotoOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateCoverPhotoOfThePackageCourse(updateCoverPhotoOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateCoverPhotoOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antremanın kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
     * @param {UpdateCoverPhotoOfTrainingCommand} [updateCoverPhotoOfTrainingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateCoverPhotoOfTraining(updateCoverPhotoOfTrainingCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateCoverPhotoOfTraining(updateCoverPhotoOfTrainingCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateCoverPhotoOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antreman setinin kapak fotoğrafını günceller. Dikkat: Resim base64 formatında gelecektir.
     * @param {UpdateCoverPhotoOfTrainingSetCommand} [updateCoverPhotoOfTrainingSetCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateCoverPhotoOfTrainingSet(updateCoverPhotoOfTrainingSetCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateCoverPhotoOfTrainingSet(updateCoverPhotoOfTrainingSetCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateDescriptionOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin açıklamasını günceller.
     * @param {UpdateDescriptionOfThePackageCourseCommand} [updateDescriptionOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateDescriptionOfThePackageCourse(updateDescriptionOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateDescriptionOfThePackageCourse(updateDescriptionOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateDescriptionOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antremanın açıklamasını günceller.
     * @param {UpdateDescriptionOfTrainingCommand} [updateDescriptionOfTrainingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateDescriptionOfTraining(updateDescriptionOfTrainingCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateDescriptionOfTraining(updateDescriptionOfTrainingCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateDescriptionOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antreman setinin açıklamasını günceller.
     * @param {UpdateDescriptionOfTrainingSetCommand} [updateDescriptionOfTrainingSetCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateDescriptionOfTrainingSet(updateDescriptionOfTrainingSetCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateDescriptionOfTrainingSet(updateDescriptionOfTrainingSetCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateIosPriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin ios fiyatını günceller.
     * @param {UpdateIosPriceOfThePackageCourseCommand} [updateIosPriceOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateIosPriceOfThePackageCourse(updateIosPriceOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateIosPriceOfThePackageCourse(updateIosPriceOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateNameOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin ismini günceller.
     * @param {UpdateNameOfThePackageCourseCommand} [updateNameOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateNameOfThePackageCourse(updateNameOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateNameOfThePackageCourse(updateNameOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePcOrderOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin sırasını günceller.
     * @param {UpdatePcOrderOfThePackageCourseCommand} [updatePcOrderOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updatePcOrderOfThePackageCourse(updatePcOrderOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updatePcOrderOfThePackageCourse(updatePcOrderOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePersonalTrainerOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Paket dersi çeken antrenörü günceller.
     * @param {UpdatePersonalTrainerOfThePackageCourseCommand} [updatePersonalTrainerOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updatePersonalTrainerOfThePackageCourse(updatePersonalTrainerOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updatePersonalTrainerOfThePackageCourse(updatePersonalTrainerOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePriceOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin fiyatını günceller.
     * @param {UpdatePriceOfThePackageCourseCommand} [updatePriceOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updatePriceOfThePackageCourse(updatePriceOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updatePriceOfThePackageCourse(updatePriceOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePromotionalVimeoUrlOfThePackageCourse - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir paket dersin tanıtım videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
     * @param {UpdatePromotionalVimeoUrlOfThePackageCourseCommand} [updatePromotionalVimeoUrlOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updatePromotionalVimeoUrlOfThePackageCourse(updatePromotionalVimeoUrlOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updatePromotionalVimeoUrlOfThePackageCourse(updatePromotionalVimeoUrlOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdatePublishStateOfThePackageCourse - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Paket dersin yayın durumunu günceller
     * @param {UpdatePublishStateOfThePackageCourseCommand} [updatePublishStateOfThePackageCourseCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updatePublishStateOfThePackageCourse(updatePublishStateOfThePackageCourseCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updatePublishStateOfThePackageCourse(updatePublishStateOfThePackageCourseCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateTitleOfTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antremanın başlığını günceller.
     * @param {UpdateTitleOfTrainingCommand} [updateTitleOfTrainingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateTitleOfTraining(updateTitleOfTrainingCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateTitleOfTraining(updateTitleOfTrainingCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateTitleOfTrainingSet - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antreman setinin başlığını günceller.
     * @param {UpdateTitleOfTrainingSetCommand} [updateTitleOfTrainingSetCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateTitleOfTrainingSet(updateTitleOfTrainingSetCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateTitleOfTrainingSet(updateTitleOfTrainingSetCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: UpdateVimeoVideoUrlOfTheTraining - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN
     * @summary Bir antremanın videosunu günceller. Gelen vimeo url\'ini VimeoService\'te bulunan GetVideoInformation metoduna gönderip gerekli değerleri alabilirsiniz.
     * @param {UpdateVimeoVideoUrlOfTheTrainingCommand} [updateVimeoVideoUrlOfTheTrainingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseAdministrationApi
     */
    updateVimeoVideoUrlOfTheTraining(updateVimeoVideoUrlOfTheTrainingCommand, options) {
        return (0, exports.PackageCourseAdministrationApiFp)(this.configuration).updateVimeoVideoUrlOfTheTraining(updateVimeoVideoUrlOfTheTrainingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PackageCourseAdministrationApi = PackageCourseAdministrationApi;
